import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { brandingUrls } from '../../config/branding';

/**
 * 工作台列表空态（桌面 / 手机共用）。
 * fill：桌面占满卡片剩余高度；action：无数据时的主操作（如新建）。
 */
const AppWorkbenchEmptyState = ({
	keyword,
	hasActiveFilters = false,
	onResetFilters,
	emptyTitle = '暂无数据',
	noMatchTitle = '没有匹配的结果',
	emptyDescription = '有数据后会显示在这里。',
	filterNoMatchDescription = '当前筛选条件下没有结果，可放宽条件或清空筛选后重试。',
	emptyIcon,
	fill = false,
	actionLabel,
	onAction,
	actionVariant = 'primary',
}) => {
	const trimmedKeyword = String(keyword ?? '').trim();
	const isKeywordOnly = Boolean(trimmedKeyword) && !hasActiveFilters;
	const isNoMatch = hasActiveFilters || isKeywordOnly;

	return (
		<div
			className={[
				'order-list-mobile-empty',
				'app-workbench-mobile-empty',
				fill ? 'app-workbench-empty--fill' : '',
			]
				.filter(Boolean)
				.join(' ')}
		>
			<div className='order-list-mobile-empty__icon' aria-hidden>
				{isNoMatch ? (
					<FontAwesomeIcon icon={isKeywordOnly ? 'search' : 'filter'} />
				) : emptyIcon ? (
					<FontAwesomeIcon icon={emptyIcon} />
				) : (
					<img src={brandingUrls.login} alt='' className='app-workbench-mobile-empty__logo' />
				)}
			</div>
			<h3 className='order-list-mobile-empty__title'>{isNoMatch ? noMatchTitle : emptyTitle}</h3>
			<p className='order-list-mobile-empty__desc'>
				{isKeywordOnly
					? `未找到与「${trimmedKeyword}」相关的内容，请换个关键词试试。`
					: hasActiveFilters
						? filterNoMatchDescription
						: emptyDescription}
			</p>
			{isNoMatch && onResetFilters ? (
				<Button size='sm' variant='outline-primary' type='button' onClick={onResetFilters}>
					{hasActiveFilters ? '清空筛选' : '清空搜索'}
				</Button>
			) : null}
			{!isNoMatch && actionLabel && onAction ? (
				<Button size='sm' variant={actionVariant} type='button' onClick={onAction}>
					{actionLabel}
				</Button>
			) : null}
		</div>
	);
};

AppWorkbenchEmptyState.propTypes = {
	keyword: PropTypes.string,
	hasActiveFilters: PropTypes.bool,
	onResetFilters: PropTypes.func,
	emptyTitle: PropTypes.string,
	noMatchTitle: PropTypes.string,
	emptyDescription: PropTypes.string,
	filterNoMatchDescription: PropTypes.string,
	emptyIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	fill: PropTypes.bool,
	actionLabel: PropTypes.string,
	onAction: PropTypes.func,
	actionVariant: PropTypes.string,
};

export default AppWorkbenchEmptyState;
